var requestAccountStrings = {
    requestAccount: {
        title: 'Request New Account',
        subHeader: 'Please complete all mandatory fields * below and submit.',
    },
    sectionTitles: {
        accountInfo: 'Account Information',
        accountManagerContactInfo: 'Account Manager Contact Information',
    },
    helpTooltip: {
        prefix: 'Please ensure the ',
        linkText: 'GFW Pro URL Allow List',
        suffix: ' is added to your organization’s network settings.',
        link: 'https://www.globalforestwatch.org/help/gfw-pro/additional-materials/gfw-pro-url-allowlist/',
        explanation: 'This will help maintain uninterrupted access to our tools and ensure reliable communication with our team. Kindly share the allow list with your IT department to prevent any connection issues or blocked services.',
    },
};
export default requestAccountStrings;
